import React, { Component } from "react";
import { Select, Spin } from "antd";
import { cmmsPost } from "../cmmsComun";

const { Option } = Select;

const etiqueta = (a) =>
    [a.codigo, a.tipoNombre, [a.marcaNombre, a.modeloNombre].filter(Boolean).join(" "), a.sinSerie ? "Sin serie" : a.numeroSerie && `Serie ${a.numeroSerie}`, a.clienteId ? a.clienteNombre : "Sin cliente"]
        .filter(Boolean)
        .join(" · ");

// Buscador de activos CMMS (folio, serie, inventario, ID externo, tipo, marca, cliente).
// Compatible con FormItem. onChange(value, activo). props.textoInicial = etiqueta del
// valor precargado (para no tener que consultarlo).
class SelectActivoCMMS extends Component {
    state = { opciones: [], cargando: false };
    temporizador = null;

    componentDidMount() {
        this.buscar("");
    }

    componentWillUnmount() {
        clearTimeout(this.temporizador);
    }

    buscar = (texto) => {
        clearTimeout(this.temporizador);
        this.temporizador = setTimeout(async () => {
            this.setState({ cargando: true });
            try {
                const res = await cmmsPost(this.props, "selectActivosCMMS", {
                    textoFiltro: texto || "",
                    page: 1,
                    pageSize: 25,
                    valor: 1,
                    ...(this.props.clienteId ? { clienteId: this.props.clienteId } : {}),
                });
                if (res.data.success === 2) this.setState({ opciones: res.data.data });
            } catch (error) {
                console.log(error);
            } finally {
                this.setState({ cargando: false });
            }
        }, 300);
    };

    render() {
        const { value, onChange, disabled, placeholder, textoInicial } = this.props;
        const opciones = [...this.state.opciones];
        const faltaValor = value && !opciones.some((o) => String(o._id) === String(value));
        return (
            <Select
                showSearch
                allowClear
                filterOption={false}
                onSearch={this.buscar}
                value={value || undefined}
                disabled={disabled}
                placeholder={placeholder || "Buscar por folio, serie, inventario, tipo o cliente"}
                notFoundContent={this.state.cargando ? <Spin size="small" /> : "Sin resultados"}
                style={{ width: "100%" }}
                dropdownMatchSelectWidth={false}
                onChange={(v) => onChange && onChange(v || null, opciones.find((o) => String(o._id) === String(v)) || null)}
            >
                {faltaValor && (
                    <Option key={value} value={value}>
                        {textoInicial || "Activo seleccionado"}
                    </Option>
                )}
                {opciones.map((a) => (
                    <Option key={a._id} value={a._id}>
                        {etiqueta(a)}
                    </Option>
                ))}
            </Select>
        );
    }
}

export default SelectActivoCMMS;
